import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PageHeader({ eyebrow, title, subtitle, primary, secondary }) {
  return (
    <section className="relative overflow-hidden bg-[#0B1220] text-white">
      <div className="absolute inset-0 opacity-30" style={{ backgroundImage: "radial-gradient(circle at 20% 30%, #0057B8 0, transparent 45%), radial-gradient(circle at 80% 70%, #0E7490 0, transparent 45%)" }} />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 sm:pt-20 sm:pb-28">
        {eyebrow && <span className="text-sm font-semibold uppercase tracking-widest text-[#F59E0B]">{eyebrow}</span>}
        <h1 className="mt-2 font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-4 text-white/80 max-w-2xl text-base sm:text-lg leading-relaxed">{subtitle}</p>}
        {(primary || secondary) && (
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            {primary && (
              <Button asChild className="bg-[#F59E0B] hover:bg-[#D97706] text-white rounded-full btn-brand h-11 px-6">
                <Link to={primary.to}>{primary.label}</Link>
              </Button>
            )}
            {secondary && (
              <Button asChild variant="outline" className="border-white/40 text-white hover:bg-white hover:text-[#0057B8] rounded-full btn-brand bg-white/5 h-11 px-6">
                <Link to={secondary.to}>{secondary.label}</Link>
              </Button>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
